export const getTotalPage = (total: number, limit: number) => {
    if (total === 0 || limit === 0) {
      return 0;
    }
    const totalPagesCount = total / limit;
    const totalPage = Math.floor(totalPagesCount);
    const isWholePage = total % limit;
    return isWholePage === 0 ? totalPage : (totalPage + 1);
};